import React from 'react'
// libs
import { Field } from 'redux-form'
import styled from 'styled-components'
// components
import TimePicker, { CustomTimePickerProps } from 'components/FormElements/TimePicker'
import FormControl from '@mui/material/FormControl'
// views
import ErrorMessage, { ErrorMessageWrapper } from 'components/UI/ErrorMessage'
// types
import { WrappedFieldProps } from 'redux-form/lib/Field'

const ReduxTimePickerWrapper = styled(FormControl)`
  && {
    position: relative;
  }
`

type Props = Omit<CustomTimePickerProps, 'onError' | 'onChange'>

const renderComponent = ({
  meta: { touched, error },
  input: { value, onChange },
  ...rest
}: Props & WrappedFieldProps) => {
  return (
    <ReduxTimePickerWrapper margin='none' fullWidth>
      <TimePicker {...rest} value={value} onChange={onChange} />
      {touched && error && (
        <ErrorMessageWrapper>
          <ErrorMessage>{error}</ErrorMessage>
        </ErrorMessageWrapper>
      )}
    </ReduxTimePickerWrapper>
  )
}

const ReduxTimePicker: React.FC<Props> = (props) => <Field {...props} component={renderComponent} />

export default ReduxTimePicker
